import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from '~/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '~/components/ui/dialog';

type SignatureDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: (signatureDataUrl: string) => void;
    isLoading?: boolean;
};

const SignatureDialog = ({ open, onOpenChange, onConfirm, isLoading }: SignatureDialogProps) => {
    const sigCanvasRef = useRef<SignatureCanvas | null>(null);
    const [isEmpty, setIsEmpty] = useState(true);

    const handleClear = () => {
        sigCanvasRef.current?.clear();
        setIsEmpty(true);
    };

    const handleConfirm = () => {
        if (!sigCanvasRef.current || isEmpty) {
            return;
        }

        const dataUrl = sigCanvasRef.current.toDataURL('image/png');
        onConfirm(dataUrl);
    };

    const handleEnd = () => {
        if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
            setIsEmpty(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-lg">
                <DialogHeader>
                    <DialogTitle>Unterschrift</DialogTitle>
                    <DialogDescription>
                        Bitte unterschreiben Sie, um den Kassensturz abzuschließen.
                    </DialogDescription>
                </DialogHeader>

                <div className="flex flex-col items-center gap-3">
                    <div className="w-full rounded-md border border-gray-300 bg-white">
                        <SignatureCanvas
                            ref={sigCanvasRef}
                            canvasProps={{
                                width: 440,
                                height: 200,
                                className: 'w-full rounded-md',
                            }}
                            penColor="#333333"
                            onEnd={handleEnd}
                        />
                    </div>

                    <Button
                        variant="outline"
                        size="sm"
                        onClick={handleClear}
                        type="button"
                    >
                        Löschen
                    </Button>
                </div>

                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isLoading}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        disabled={isEmpty || isLoading}
                    >
                        {isLoading ? 'Wird gespeichert...' : 'Bestätigen & Speichern'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default SignatureDialog;
